<template>
    <div>
        <equipment-schedule name-table="client-contract-maintenance-equipment-schedule" :settings="settings" :general="general" :maint-data="sorItem" :is-equipment-schedule="true"></equipment-schedule>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    const equipmentSchedule = () => import("../asset-management/equipment-schedule.vue")
    export default {
        name: 'maintenance-program-maintenance-schedule',
        components: {
            equipmentSchedule
        },
        data() {
            return {
                queryParam: { id: this.$route.params.id },
                settings: {
                    showBtnMassSchedule: false,
                    showDropDownMaint: false,
                    create: true,
                    title_modal: 'Equipment Maintenance Schedule',
                },
                general: {
                    contract_id: null,
                    contract_term_id: null,
                    property_id: null,
                    equipment_group_id: null
                },
            }
        },
        computed: {
            ...mapGetters({
                sorItem:  'v2SorController/sorItem'
            })
        },
        created() {
            if(this.$route.params.maintenance_id != 0 && this.sorItem.id != this.$route.params.maintenance_id){
                this.$store.dispatch("v2SorController/getItem", this.$route.params.maintenance_id)
                .then(response => {
                    if(response.data.data.code && response.data.data.code == 400) {
                        if(this.$route.params.id) {
                            return this.$router.push(`/v2/contract-client/${this.$route.params.id}/maintenance-program`)
                        } else {
                            this.$router.push(`/v2/maintenance-program`)
                        }
                    }
                });
            }

            //Disable schedule tabs if create new
            if(this.$route.params.maintenance_id == 0){
                this.disabledTab = true;
            }

            if(this.sorItem && this.sorItem.id) {

                this.general.contract_id        = this.sorItem.contract_term && this.sorItem.contract_term.contract_id  ? this.sorItem.contract_term.contract_id  : null;
                this.general.contract_term_id   = this.sorItem.contract_term_id  ? this.sorItem.contract_term_id : null;
                this.general.property_id        = this.sorItem.property_id
                this.general.equipment_group_id = this.sorItem.equipment_group_id
            }
        },
        watch: {
            sorItem: function(val) {
                if(val && val.id) {
                    this.general.contract_id        = val.contract_term && val.contract_term.contract_id  ? val.contract_term.contract_id  : null;
                    this.general.contract_term_id   = val.contract_term_id  ? val.contract_term_id : null;
                    this.general.property_id        = val.property_id
                    this.general.equipment_group_id = val.equipment_group_id
                }
            }
        },
        methods: {

        }
    }
</script>
